<template>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>新增课程目录</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            
            <v-text-field
              v-model="formData.name"
              label="目录名称"
              :rules="[v => !!v || '请输入目录名称']"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">取消</v-btn>
          <v-btn color="blue darken-1" text @click="submit">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import { courseApi } from '@/api/course'
  
  export default {
    name: 'EditCourseCategoryPopup',
    data() {
      return {
        dialog: false,
        valid: false,
        formData: {
          id: '',
          name: '',
        //   categoryTypeId = 0 , 是课程的目录类型
          categoryTypeId: 0
        },
        courseTopics: [] // 这里需要从后端获取课程主题列表
      }
    },
    methods: {
      open(item) {
        this.formData.id = item.categoryId;
        this.formData.name = item.name;
        this.dialog = true
      },
      close() {
        this.dialog = false
        this.$refs.form.reset()
      },
      async submit() {
        if (!this.$refs.form.validate()) return
        
        try {
          await courseApi.updateCategory(
            { "id": this.formData.id, "name": this.formData.name });
          this.$emit('category-updated');
          this.close();
          this.$toast.success('更新成功')
        } catch (error) {
          const errorMessage = error.response?.data?.message || error.message || '未知错误';
          this.$toast.error('更新失败：' + errorMessage);
        }
      }
    }
  }
  </script> 